import script from "./brands.vue?vue&type=script&setup=true&lang=js"
export * from "./brands.vue?vue&type=script&setup=true&lang=js"

import "./brands.vue?vue&type=style&index=0&id=211f2b36&lang=scss&scoped=true"
import "./brands.vue?vue&type=style&index=1&id=211f2b36&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_ad\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-211f2b36"]])

export default __exports__